import { render, staticRenderFns } from "./stopwatch.vue?vue&type=template&id=23d08a64&scoped=true&"
import script from "./stopwatch.vue?vue&type=script&lang=js&"
export * from "./stopwatch.vue?vue&type=script&lang=js&"
import style0 from "./stopwatch.vue?vue&type=style&index=0&id=23d08a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d08a64",
  null
  
)

export default component.exports